import { useMemo, useState, useEffect } from 'react'
import { DEFAULT_BOUNDARIES, FIRST_PAGE, DEFAULT_SIBLINGS } from './Pagination.consts'
import { PaginationData } from './Pagination.types'
import { getPaginationRange } from './Pagination.utils'

function usePagination({
  page,
  total,
  siblings = DEFAULT_SIBLINGS,
  boundaries = DEFAULT_BOUNDARIES,
  firstPageIndex = FIRST_PAGE,
  onChange,
}: PaginationData) {
  const [currentPage, setCurrentPage] = useState(page)

  useEffect(() => setCurrentPage(page), [page])

  const setPage = (pageNumber: number) => {
    const newPage = Math.max(Math.min(pageNumber, total), firstPageIndex)

    setCurrentPage(newPage)

    if (onChange) {
      onChange(newPage)
    }
  }

  const next = () => setPage(currentPage + 1)
  const previous = () => setPage(currentPage - 1)
  const first = () => setPage(firstPageIndex)
  const last = () => setPage(total)

  const paginationRange = useMemo(() => getPaginationRange(currentPage, total, siblings, boundaries), [boundaries, currentPage, siblings, total])

  return {
    range: paginationRange,
    current: currentPage,
    setPage,
    next,
    previous,
    first,
    last,
  }
}

export default usePagination
